export default __webpack_public_path__ + "static/media/twiggleArrow.bcdc5a66.svg";